// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"B_PH_TheComp__W6RCQ"};